var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.25V12.4387L11.1213 11.0681L12.1819 12.1287L9 15.3106L5.81802 12.1287L6.87868 11.0681L8.25 12.4387V8.25H9.75ZM9 0C11.6951 0 13.9158 2.03071 14.2156 4.64546C15.9643 5.12365 17.25 6.7242 17.25 8.625C17.25 10.7766 15.6027 12.5435 13.5005 12.7332L13.5007 11.2233C14.7725 11.041 15.75 9.94718 15.75 8.625C15.75 7.17525 14.5747 6 13.125 6C12.9684 6 12.815 6.01372 12.6665 6.0405C12.7212 5.78565 12.75 5.52118 12.75 5.25C12.75 3.17894 11.071 1.5 9 1.5C6.92894 1.5 5.25 3.17894 5.25 5.25C5.25 5.52118 5.27879 5.78565 5.33404 6.03998C5.18498 6.01372 5.03159 6 4.875 6C3.42525 6 2.25 7.17525 2.25 8.625C2.25 9.90022 3.15931 10.963 4.36489 11.2005L4.50004 11.2234L4.50029 12.7332C2.39772 12.5439 0.75 10.7769 0.75 8.625C0.75 6.7242 2.03568 5.12365 3.78486 4.64558C4.08421 2.03071 6.30496 0 9 0Z",
    fill: "#2E3031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export_icon.16e94fad2512de5d7fb4bc80499e8992.svg";
export { ForwardRef as ReactComponent };